import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/product/orders?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/product/orders/${id}`, { params });
}

export async function create(body) {
  return request(`/product/orders`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/product/orders/${id}`, {
    method: 'POST',
    body,
  });
}

export async function syncOne(params, id, partner_id) {
  return request(`/product/sync-order/order/${id}/partner/${partner_id}`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function syncKiotViet(params) {
  return request(`/product/kiotviet/sync-order`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function partnerApproved(params) {
  return request(`/product/orders/${params.id}/partner-confirm`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function adminApproved(params) {
  return request(`/product/orders/${params.id}/admin-confirm`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

export async function cancelOrder(params) {
  return request(`/product/orders/${params.id}/cancel`, {
    method: 'POST',
    body: {
      ...params
    }
  });
}

